import { DocumentNode, QueryHookOptions, gql } from '@apollo/client';
import { useMemo } from 'react';
import { useGraphql } from 'utils/hooks/useGraphql';

export const queryTemplateFolderDetails = gql`
  query templateFolderDetails($folderId: Long!) {
    templateFolderDetails(folderId: $folderId) {
      id
      name
      ancestorIds
      subfolderIds
      contentIds
    }
  }
`;

type QueryTemplateFolderDetailsVariables = {
  folderId: number;
};

type QueryTemplateFolderDetailsResponse = {
  templateFolderDetails: {
    id: number;
    name: string;
    ancestorIds: number[];
    subfolderIds: number[];
    contentIds: number[];
  };
};

type QueryTemplateFolderDetailsOptions = QueryHookOptions<
  QueryTemplateFolderDetailsResponse,
  QueryTemplateFolderDetailsVariables
>;

export const useTemplateFolderDetails = (
  options: QueryTemplateFolderDetailsOptions,
  query: DocumentNode = queryTemplateFolderDetails,
) => {
  const queryOptions: QueryTemplateFolderDetailsOptions = useMemo(
    () => ({
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'no-cache',
      skip: !options?.variables?.folderId,
      ...options,
    }),
    [options],
  );

  const {
    data,
    errorMessage,
    isLoading,
    error: hasError = false,
    refetch,
  } = useGraphql<QueryTemplateFolderDetailsResponse, QueryTemplateFolderDetailsVariables>(
    query,
    queryOptions,
  );

  return {
    templateFolderDetails: data?.templateFolderDetails,
    errorMessage,
    hasError,
    isLoading,
    refetch,
  };
};
